/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EvaluationScoreInterface } from '../../+models';
import { SetEvaluationScoresForTaskResponseInterface } from '../../evaluation-score';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EvaluationScoreApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EvaluationScores');
  }

  setEvaluationScoresForTask(
    taskId: number,
    evaluationScores: EvaluationScoreInterface[]
  ): Observable<SetEvaluationScoresForTaskResponseInterface> {
    const path = `task/${taskId}`;
    return this.post(path, undefined, evaluationScores);
  }
}
